var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const g_hiddenFileInputBtnId = "pdf_file_append_dynamic";
const _fileInputId = g_hiddenFileInputBtnId;
let _acc = 0;
let _fileOpenPromise = null;
let _resolveFunc = null;
// let _filename = "";
let _isRunning = false;
export function openFileBrowser2() {
    return __awaiter(this, void 0, void 0, function* () {
        // const result: IFileBrowserReturn = {
        //   result: "failed",
        //   file: null,
        //   url: null,
        // }
        console.log(`try to load: click simulation ${_acc++}`);
        _fileOpenPromise = new Promise(resolve => _resolveFunc = resolve);
        performClick2(_fileInputId);
        return _fileOpenPromise;
    });
}
function performClick2(elemId) {
    return __awaiter(this, void 0, void 0, function* () {
        // _filename = "";
        const elem = document.getElementById(elemId);
        if (elem && document.createEvent) {
            const evt = document.createEvent("MouseEvents");
            evt.initEvent("click", true, false);
            elem.dispatchEvent(evt);
        }
    });
}
export function openFileBrowser() {
    return __awaiter(this, void 0, void 0, function* () {
        let result = yield performClick(_fileInputId);
        const file = result.file;
        if (file) {
            const url = URL.createObjectURL(file);
            result = Object.assign(Object.assign({}, result), { url });
            console.log(file.name);
        }
        return result;
    });
}
function performClick(elemId) {
    return __awaiter(this, void 0, void 0, function* () {
        // _filename = "";
        _fileOpenPromise = new Promise(resolve => {
            const elem = document.getElementById(elemId);
            if (elem && document.createEvent) {
                const evt = document.createEvent("MouseEvents");
                evt.initEvent("click", true, false);
                elem.dispatchEvent(evt);
                _resolveFunc = resolve;
                return _fileOpenPromise;
            }
            else {
                resolve({ result: "failed", file: undefined, url: undefined });
            }
        });
        return _fileOpenPromise;
    });
}
// async function performClick_old(elemId): Promise<IFileBrowserReturn> {
//   // _filename = "";
//   const elem = document.getElementById(elemId);
//   if (elem && document.createEvent) {
//     _fileOpenPromise = new Promise(resolve => {
//       const evt = document.createEvent("MouseEvents");
//       evt.initEvent("click", true, false);
//       elem.dispatchEvent(evt);
//       _resolveFunc = resolve;
//     });
//     return _fileOpenPromise;
//   }
//   return Promise.resolve({ result: "failed", file: undefined, url: undefined });
// }
function handleFocusBack(e) {
    const func = _resolveFunc;
    _isRunning = false;
    setTimeout(() => {
        _resolveFunc = undefined;
        const result = {
            result: "failed",
            file: null,
            url: null,
        };
        if (_isRunning) {
            func(result);
        }
    }, 500);
    document.body.onfocus = null;
}
export function onFileInputChanged(e) {
    window.removeEventListener('focus', handleFocusBack);
    _isRunning = false;
    const func = _resolveFunc;
    _resolveFunc = undefined;
    const file = e.target.files[0];
    const url = URL.createObjectURL(file);
    console.log("OK : " + file.name);
    // _filename = file.name;
    e.target.value = null;
    if (func !== undefined)
        func({ result: "success", url, file });
}
export function onFileInputClicked(e) {
    document.body.onfocus = handleFocusBack;
    _isRunning = true;
    // window.addEventListener('focus', handleFocusBack);
}
//# sourceMappingURL=FileBrowser.js.map